<template>
    <ul>
        <li v-for="(tab, idx) in internalTabs"
            @click="selectTab(tab, idx)"
            :key="`${tab.label}_${tab.active}` "
            :class="{active: tab.active}"
            :id="`proposalEditTab${tab.label}`">
            <a href="javascript:void(0)">
                <svg-icon :icon="tab.icon"/>
                <span class="label" style="white-space: nowrap">{{tab.label}}</span>
                <transition name="badge">
                    <span class="badge" :class="tab.badge_class" v-if="tab.badge && tab.badge !== ''">{{tab.badge}}</span>
                </transition>
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "Tabs",
        props: {
            tabs: {
                type: Array,
                default: () => [{
                    icon: 'save',
                    label: '[definir nome]',
                    active: false
                }]
            }
        },
        methods: {
            selectTab(tab, idx) {
                this.tabs.forEach(t => t.active = false);

                tab.active = true;

                this.$emit('onTabSelected', {tab: tab, index: idx});
            }
        },
        computed: {
            internalTabs() {
                return this.tabs.slice();
            }
        }
    }
</script>
<style lang="scss" scoped>

    .badge-enter-active, .badge-leave-active {
        transition: opacity .2s ease-in-out;
        transition-delay: .1s;
    }
    .badge-enter, .badge-leave-to {
        opacity: 0;
        zoom: 0;
    }
</style>
